import * as React from 'react'
import { Box, Typography } from '@mui/material'


export default function sellerColumn(label) {
    return {
        name: 'name', label: 'Seller',
        options: {
            customBodyRowRenderLite: (value) => <Box sx={{ textAlign: 'center' }}>
            <Typography >{value}</Typography>
        </Box>
        }
    }
}